import Vue from 'vue'
import Vuex from 'vuex'

import axios from "axios";
import Config from "@/config"

Vue.use(Vuex)

export const APIKEY_STORAGE_KEY = "api-key";

const state = {
  apiKey: window.localStorage.getItem(APIKEY_STORAGE_KEY),
  isApiKeyValid: false,
  isApiKeyVerifying: false,
}

const getters = {}

const actions = {
  tryApiKey({commit}, key) {
    axios.defaults.headers.common['X-Api-Key'] = key;
    commit("setVerifying", true);
    axios.get(Config.healthUrl).then(() => {
      commit("setValid", true)
  }).catch((e) => {
      if (!e.response || e.response.status !== 403) {
      console.error("Impossible de contacter le serveur pour vérifier la clé d'API")
    }
    commit("setValid", false);
  }).finally(() => {
      commit("setApiKey", key);
    commit("setVerifying", false);
  })
  }
}

const mutations = {
  setApiKey(state, key) {
    state.apiKey = key;
  },
  setValid(state, isValid) {
    state.isApiKeyValid = isValid;
  },
  setVerifying(state, isVerifying) {
    state.isApiKeyVerifying = isVerifying;
  }
}

const storagePlugin = store => {
  store.subscribe((mutation, {apiKey}) => {
    window.localStorage.setItem(APIKEY_STORAGE_KEY, apiKey)
  })
}

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: [storagePlugin]
});

// Si une clé à été récupérée du localStorage, on lance directement le test
if (state.apiKey) {
  store.dispatch("tryApiKey", state.apiKey)
}

export default store;
